import {useTranslation} from "react-i18next";
import {useEffect, useRef} from "react";
import {Button, Form, Input, InputNumber, Switch} from "antd";
import ApiService from "../../core/service/api-service";
import HospitalSelectBox from "../hospital/HospitalSelectBox";
import ModalitySelectBox from "../modality/ModalitySelectBox";
import {useHistory} from "react-router-dom";
import {Pages} from "../../AppRouter";

export default function DeviceCreateEdit({deviceId, onSaved})
{
    const {t} = useTranslation();
    const history = useHistory();
    const formRef = useRef();

    const getDevice = async () => {
        if(deviceId)
        {
            const response = await ApiService.Device.GetById(deviceId);
            if(response.success)
            {
                formRef.current.setFieldsValue({
                    name: response.data.name,
                    aeTitle: response.data.aeTitle,
                    ipAddress: response.data.ipAddress,
                    port: response.data.port,
                    hospitalId: response.data.hospitalId,
                    modalityId: response.data.modalityId,
                    isActive: response.data.isActive,
                    defaultAppointmentDevice: response.data.defaultAppointmentDevice,
                })
            }
        }
    }

    const save = async (form) => {
        let response;
        if(deviceId)
        {
            response = await ApiService.Device.Update({
                ...form,
                id: parseInt(deviceId)
            });
        }
        else
        {
            response = await ApiService.Device.Create(form);
        }

        if(response.success)
        {
            if(onSaved) {
                onSaved();
            } else if(!deviceId) {
                history.push(Pages.Device.Edit(response.data));
            }
        }
    }

    useEffect(() => {
        getDevice()
    }, [deviceId])

    return (
        <>
            <Form
                layout={'vertical'}
                ref={formRef}
                onFinish={save}
                initialValues={{
                    isActive: true,
                    port: 104,
                    defaultAppointmentDevice: false
                }}
            >
                <Form.Item
                    label={t('Hospital')}
                    name={'hospitalId'}
                    rules={[
                        {required: true, message: t('Please select a hospital')}
                    ]}
                >
                    <HospitalSelectBox mode={'single'} />
                </Form.Item>

                <Form.Item
                    label={t('Modality')}
                    name={'modalityId'}
                    rules={[
                        {required: true, message: t('Please select a modality')}
                    ]}
                >
                    <ModalitySelectBox mode={'single'} />
                </Form.Item>

                <Form.Item
                    name={'name'}
                    label={t('Device Name')}
                    rules={[
                        {required: true, message: t('Please enter device name')}
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name={'aeTitle'}
                    label={t('AE Title')}
                    rules={[
                        {required: true, message: t('Please enter AE Title')}
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name={'ipAddress'}
                    label={t('IP Address')}
                    rules={[
                        {required: true, message: t('Please enter IP address')}
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name={'port'}
                    label={t('Port')}
                    rules={[
                        {required: true, message: t('Please enter port number')}
                    ]}
                >
                    <InputNumber style={{width: '100%'}} min={1} max={65535} />
                </Form.Item>

                <Form.Item
                    name={'isActive'}
                    label={t('Active')}
                    valuePropName="checked"
                >
                    <Switch />
                </Form.Item>

                <Form.Item
                    name={'defaultAppointmentDevice'}
                    label={t('Default Appointment Device')}
                    valuePropName="checked"
                >
                    <Switch />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        {t('Save')}
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}
